var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoneGreyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.178,
    height: 40.987,
    viewBox: "0 0 66.178 40.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8889",
    "data-name": "Group 8889",
    transform: "translate(-2943.865 -307.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M2969.685,330.779c.431.081.843.362,1.307.1.062-.035.149.013.218.1.261.338.466.344.763.057.377-.363.477-.336.725.086.22.375.491.721.742,1.078a5.08,5.08,0,0,1,.408.8,1.718,1.718,0,0,1-.481,2.139c-.264.257-.537.672-.226.937a.826.826,0,0,0,1-.213c.142-.157.249-.237.388.039.175.346.64.21.9.453a.176.176,0,0,0,.132-.136.456.456,0,0,0-.364-.416.668.668,0,0,1-.506-.626c-.007-.107-.036-.216-.161-.249a.318.318,0,0,0-.348.157c-.132.177-.225.4-.545.409a1.613,1.613,0,0,1,.5-.74,1.015,1.015,0,0,0,.278-.953,4.865,4.865,0,0,0-1.351-2.673c.112-.112.257-.037.347-.126.04-.379.4-.139.557-.284.038-.243-.157-.315-.315-.336a.8.8,0,0,1-.482-.277.446.446,0,0,0-.124-.046.5.5,0,0,0-.262.03c-.225.116-.365.334-.617.439a.974.974,0,0,1-.944.049.569.569,0,0,0-.485-.019,1.3,1.3,0,0,1-.841.005C2969.785,330.6,2969.674,330.627,2969.685,330.779Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M2981.814,336.7a.217.217,0,0,0,.2-.062c.126-.124.39.117.431-.1s-.169-.367-.33-.5c-.04-.033-.085-.061-.183-.13a8.106,8.106,0,0,1,1.135.011,1.146,1.146,0,0,0,.9-.15c.378-.263.445.186.65.352.122-.756-.239-1.2-.926-1.231a11.088,11.088,0,0,1-2.822-.4,6.6,6.6,0,0,0-1.348-.184.72.72,0,0,1-.687-.54,6.016,6.016,0,0,0-.828-1.7,1,1,0,0,1-.206-.892c.06-.156-.012-.249-.149-.312a1.373,1.373,0,0,1-.728-.005.153.153,0,0,0-.095.084.305.305,0,0,0,.135.353c.319.094.454.332.6.621.351.7.722,1.393,1.022,2.121a.9.9,0,0,0,.45.495c.733.19,1.494.237,2.22.456.886.177,1.8.163,2.681.4a4.457,4.457,0,0,1-2.5-.061c-.256.152-.092.3.049.342.206.07.173.213.187.355.233.325-.076.4-.248.543C2981.494,336.772,2981.707,336.6,2981.814,336.7Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M2981.814,336.7c-.082-.133-.3-.013-.357-.191a.98.98,0,0,0-.971-.327c-.8.092-1.6-.054-2.4.037a.566.566,0,0,1-.471-.13c-.359-.356-.9-.448-1.225-.854a.219.219,0,0,0-.281-.086c-.131.074-.114.205-.074.323a.941.941,0,0,0,.475.53,8.235,8.235,0,0,0,1.536.874c.056.016.1.07.086.216-.5-.155-1.051-.013-1.478-.412a1.877,1.877,0,0,0-1.113-.432l-.112.109a3.525,3.525,0,0,0,2.072,1.014,1.674,1.674,0,0,1,.65.154c.123.058.268.271.383.122a.761.761,0,0,0,.247-.645,2.222,2.222,0,0,0-.149-.341,1.138,1.138,0,0,1,.7-.084C2980.15,336.689,2980.988,336.565,2981.814,336.7Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M2980.988,309.917c-.114.2-.086.542-.471.475-.025.263-.249.416-.352.636-.088.189-.074.448-.392.457-.119,0-.034.1-.011.162.137.366-.448-.026-.324.3.088.23.146.418-.2.417-.277,0-.554-.04-.832-.039a2.855,2.855,0,0,0-.88-.03.339.339,0,0,0,.012.386.835.835,0,0,0,.6.083c.3-.054.622.126.933-.049.061-.034-.008.026-.012.034-.073.157.03.218.144.275.121.031.216.139.354.122a11.16,11.16,0,0,0,.589-1.107,1.141,1.141,0,0,1,.405-.475.473.473,0,0,0,.255-.3.845.845,0,0,1,.461-.679c.077-.037.09-.153.1-.245C2981.341,309.833,2981.315,309.8,2980.988,309.917Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M2972.6,313.744c-.2-.07-.379-.144-.473.149a.391.391,0,0,1-.332.275,5.343,5.343,0,0,0-1.367.606c-.5.218-.869.632-1.375.816-.217.079-.186.306-.32.446-.2.207-.515.316-.606.624a.3.3,0,0,0,.081.1c.231.216.425.281.553-.105a.555.555,0,0,1,.336-.29,1.152,1.152,0,0,0,.424-.393,1.892,1.892,0,0,1,1.272-.841c.075-.008.182,0,.214-.058.257-.439.786-.4,1.147-.663.149-.108.39-.011.562-.167.112-.1.261-.159.221-.351C2972.861,313.75,2972.766,313.659,2972.6,313.744Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M2991.316,315.577c.1-.018.086-.1.083-.165a1.935,1.935,0,0,1,1-.034c.335.116.635-.1.962-.107.234,0,.171-.252.138-.4a2.788,2.788,0,0,0-.691-1.15q-.346-.411-.694-.824a.832.832,0,0,1-.225-.733c.068-.353-.163-.66-.2-1-.138.087-.142.254-.225.374-.041.131,0,.27-.026.41-.13-.082-.173-.29-.367-.23a.218.218,0,0,0-.142.292c.048.189-.059.477.237.521a.842.842,0,0,1,.563.411c.389.517.876.957,1.221,1.509.085.136.275.3,0,.442a.765.765,0,0,0-.15.115c-.291.185-.579-.015-.869-.009-.163,0-.327-.01-.491-.01-.3.007-.595-.012-.892.015a1.313,1.313,0,0,0-.5.165.144.144,0,0,0-.037.137c.16.236.368.182.582.1C2990.9,315.163,2991.078,315.493,2991.316,315.577Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M2991.113,320.309c-.177-.579-.079-1.22-.481-1.767-.1-.138.007-.541-.141-.8-.037-.065-.04-.154-.087-.206a3.453,3.453,0,0,1-.348-.334c-.12-.173.3-.143.166-.4-.061-.117.17-.258.267-.39.084-.11.219-.218.02-.344a2.707,2.707,0,0,0-1.53.934.205.205,0,0,0,.083.173c.622-.08.753.5,1.086.81a.432.432,0,0,0,.066.055c.048.034.051.056-.015.065-.138.019-.143.117-.13.225a14.647,14.647,0,0,1,.464,1.443.94.94,0,0,0,.391.577A.183.183,0,0,0,2991.113,320.309Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M2991.113,320.309h-.16c-.089.32-.089.32.082.7-.165-.156-.361-.251-.363.039,0,.468-.074.937-.12,1.391a2.719,2.719,0,0,1-.531,1.484.683.683,0,0,0-.2.481c.024.116.012.256.183.275a5.006,5.006,0,0,0,1.132-2.868A2.736,2.736,0,0,0,2991.113,320.309Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M2988.026,307.89c-.071-.051-.144-.15-.214-.148a1.585,1.585,0,0,1-1.268-.417c-.074-.074-.168-.027-.222.067-.089.157-.134.153-.286.014-.312-.287-.244.225-.441.235a.759.759,0,0,0-1.142.156c-.035.072-.141.117-.086.223.719-.221,1.425.1,2.139.05a1.781,1.781,0,0,1,1.006.1c.214.041.436.215.633-.038C2988.174,308.018,2988.072,307.968,2988.026,307.89Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M2964.5,323.587c-.155.315.231.588.068.9.442.333-.038.965.433,1.321a2.588,2.588,0,0,1,.291.422.165.165,0,0,0,.186.032,1.207,1.207,0,0,0-.124-.98c-.063-.139-.162-.266-.122-.421a3.147,3.147,0,0,0-.038-1.074.582.582,0,0,0-.5-.6c-.167.011-.2.11-.158.25C2964.555,323.5,2964.643,323.566,2964.5,323.587Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M2984.373,308.017l.08-.22c-.478-.274-.816.3-1.272.213-.091-.018-.141.132-.2.215-.15.2-.3.41-.609.387a.746.746,0,0,0-.58.346c-.263.323-.532.64-.8.959.452-.072.218.279.277.45.167.05.151-.1.194-.18a2.938,2.938,0,0,1,1.314-1.339,7.111,7.111,0,0,0,1.508-.694C2984.328,308.114,2984.38,308.088,2984.373,308.017Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M2966.3,318.728c-.081.045-.04.152-.077.193-.308.34-.132.413.262.42a6.108,6.108,0,0,0-.943.476.373.373,0,0,0-.263.416c.048.356-.211.6-.315.9a.3.3,0,0,0,.285.131c.4-.063.334-.46.472-.7.072-.125.1-.217.253-.249s.323-.112.268-.341c-.007-.03,0-.033.119-.09a.69.69,0,0,0,.242-1.151C2966.5,318.7,2966.4,318.925,2966.3,318.728Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M2980.535,329.878c.157-.008.315.1.473-.035.259-.219.432-.6.878-.493.027-.11.216-.093.2-.221-.071-.521.371-.694.65-.979a.271.271,0,0,0-.225-.132,3.525,3.525,0,0,0-1.474,1.083c-.182.236-.6.3-.539.723Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M2977.625,312.656c-.14-.091-.063-.24-.095-.36-.057.392-.37.23-.582.256a18.454,18.454,0,0,0-2.045.513c-.327.077-.682.034-.931.324,0,.174.129.156.238.172.5,0,.949-.3,1.439-.311a17.6,17.6,0,0,0,1.769-.367C2977.55,312.866,2977.652,312.82,2977.625,312.656Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M2964.5,323.587c.073-.007.068.159.147.084.04-.038.186-.14,0-.219-.146-.063-.093-.149-.007-.228a.391.391,0,0,0,.338-.263,1.436,1.436,0,0,1,.585-.767.191.191,0,0,0,.094-.268c-.125-.206-.308-.127-.48-.079-.109.016-.224-.093-.329.013-.292.13-.248.387-.33.634-.11.333.059.667-.12.963C2964.392,323.474,2964.466,323.543,2964.5,323.587Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M2966.314,328.147a4.066,4.066,0,0,0,1.271,1.55c.135.154.257.221.33-.048a4.222,4.222,0,0,0-.4-.857c-.277-.3-.49-.75-.972-.835a.226.226,0,0,0-.122-.022C2966.325,327.973,2966.358,328.08,2966.314,328.147Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M2982.542,328.049a.2.2,0,0,0,.193.1,2.683,2.683,0,0,1,1.222-.259c.117-.014.238.008.329-.092.059-.126-.084-.268.032-.391.073-.278-.083-.356-.318-.358A2.971,2.971,0,0,0,2982.542,328.049Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M2977.635,330.884l.172.281c.207.182.371.169.5-.1.027-.058.056-.167.147-.139.3.09.557.137.743-.21.012-.022.344.005.455-.189a.256.256,0,0,0-.1-.153c-.2-.184-.4-.3-.611-.023a.192.192,0,0,1-.245.059c-.263-.121-.406.005-.486.239-.051.145-.1.183-.255.1C2977.827,330.682,2977.654,330.647,2977.635,330.884Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M2986.283,327.518c.481-.344,1.091-.447,1.554-.826a.1.1,0,0,0,.006-.128.514.514,0,0,0-.726-.1c-.4.238-.76.525-1.145.78C2985.906,327.52,2986.191,327.412,2986.283,327.518Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M2966.3,318.728c.016.086.008.2.106.226.132.032.068-.186.2-.187.118.057.256.085.288-.076.092-.469.978-.48.669-1.171-.074-.079-.127-.2-.273-.14A6.458,6.458,0,0,0,2966.3,318.728Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M2984.2,327.422c-.248.19.045.255.087.377.308-.305.633.113.973-.024a2.258,2.258,0,0,0,.478-.178c.16-.087.131-.21.064-.339-.1-.159-.271-.256-.424-.156C2985.012,327.339,2984.556,327.193,2984.2,327.422Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M2966.314,328.147a.308.308,0,0,0,.109-.224c.191-.436.166-.4-.261-.662-.237-.147-.321-.486-.458-.748-.053-.1-.031-.247-.175-.3l-.235.015a2.545,2.545,0,0,0,.337.98A9.18,9.18,0,0,1,2966.314,328.147Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M2987.817,326.552l.02.14a2.025,2.025,0,0,0,1.28-.722.179.179,0,0,0-.03-.243A.987.987,0,0,0,2987.817,326.552Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M2991.593,311.1c-.093-.1-.347-.114-.149-.363.155-.2-.28-.237-.169-.455-.479-.124-.5-.684-.874-.912a.155.155,0,0,0-.244.056.378.378,0,0,0,.1.454,4.671,4.671,0,0,1,.918,1.158.315.315,0,0,0,.225.138A.221.221,0,0,0,2991.593,311.1Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M2989,325.763a.218.218,0,0,1,.12.207c.191-.5.665-.81.886-1.292-.089-.074-.049-.182-.072-.272-.532-.067-.607.4-.79.71A1.106,1.106,0,0,0,2989,325.763Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M2968.225,330.243a1.331,1.331,0,0,0,1.1.444c.077-.1.239-.061.293-.192-.366-.365-.738-.711-1.311-.4C2968.244,330.126,2968.2,330.164,2968.225,330.243Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M2990.2,309.482a.224.224,0,0,1,.2-.115c-.244-.186-.4-.5-.771-.5-.1,0-.135-.091-.138-.191-.008-.245-.225-.187-.362-.244a.264.264,0,0,0-.219.124c.055.161.331.2.237.445a.459.459,0,0,0,.114.161A2.958,2.958,0,0,0,2990.2,309.482Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M2979.533,330.421l.115.109c.405-.07.622-.393.887-.652l.006.006c-.119-.2-.295-.335-.519-.233A.732.732,0,0,0,2979.533,330.421Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M2988.9,308.567a.274.274,0,0,0,.233-.138.234.234,0,0,0-.2-.261c-.347.031-.579-.27-.9-.278l.1.242C2988.344,308.589,2988.472,308.661,2988.9,308.567Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M2974.274,313.484c-.1-.02-.224.01-.3-.1-.226-.261-.456-.362-.717-.035a1.72,1.72,0,0,1-.659.39.292.292,0,0,1,.289.205,3.866,3.866,0,0,1,1.359-.385C2974.263,313.562,2974.272,313.515,2974.274,313.484Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M2964.852,321.86l.309.159a.474.474,0,0,1,.153-.217c.314-.276.3-.365-.071-.593l-.282-.078a.149.149,0,0,0,.014.2C2964.642,321.441,2964.778,321.657,2964.852,321.86Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M2990.471,316.112c.153.091.026.2.018.3a2.774,2.774,0,0,0,.827-.834c-.148-.354-.375-.5-.745-.291.069.129.254.082.33.2C2990.843,315.764,2990.386,315.752,2990.471,316.112Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M2967.283,317.38l.188.2c.322-.051.5-.324.742-.495a.281.281,0,0,0,.028-.41l-.118-.011C2967.9,316.968,2967.453,317.013,2967.283,317.38Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M2968.225,330.243l.122-.114c-.083-.247-.132-.527-.493-.505-.037.215-.154.141-.269.073Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M2991.593,311.1l-.213.011c-.12.191-.106.348.117.45.249-.044.135-.257.184-.394C2991.672,311.114,2991.646,311.088,2991.593,311.1Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M2992.4,315.378a1.073,1.073,0,0,0-1,.034A2.714,2.714,0,0,1,2992.4,315.378Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M2985.744,327.316a.292.292,0,0,1-.007.281c.185-.007.347-.165.546-.079-.042-.135-.267-.085-.266-.262C2985.9,327.166,2985.82,327.231,2985.744,327.316Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M2969.575,330.521c-.109.017-.248-.012-.253.166l.363.092.181-.167A.282.282,0,0,0,2969.575,330.521Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M2968.241,316.671c.03.452-.412.514-.635.755-.046.049-.13.063-.135.15.163.205.275.394-.139.392-.129,0-.129.092-.157.176s-.069.227-.107.228c-.267,0-.414.077-.3.374l-.173.021c.023.112.334.207.019.341-.027.011-.1.049-.035.083.409.2.055.376-.054.439-.339.193-.408.763-.955.633a.938.938,0,0,1-.331.946c.22.2.393.389-.02.574a.175.175,0,0,0-.062.236c.12-.15.322-.223.42-.078.126.188-.144.241-.247.29a.6.6,0,0,0-.383.509.67.67,0,0,1-.307.484c.1.188.477.15.444.32-.072.371.18.7.056,1.063a.607.607,0,0,0,.147.757c.2.185.032.6.238.854-.053.485.538.744.4,1.3.708-.418.444.148.49.407.027.012.053.026.079.04.11.2.276.165.427.077a2.383,2.383,0,0,1,.881-.187c.3-.049.458.1.439.414a2.874,2.874,0,0,0-.025.407c.03.357.165.593.578.612s.785.045.988.535c.113.272.517.262.786.244a11.605,11.605,0,0,1,2.244.1l.239-.03a.8.8,0,0,1,.477-.126c.529.072,1.057-.038,1.582,0a4.6,4.6,0,0,0,1.31.014.423.423,0,0,1,.516.338c.042.166.084.345.294.349.174.005.269-.13.32-.28a.533.533,0,0,1,.688-.356.572.572,0,0,0,.741-.416c.091-.3.338-.362.624-.321.39.055.742.036.835-.456.006-.029.026-.069.049-.074.577-.124.685-.76,1.128-1.028a.323.323,0,0,0,.162-.153c.163-.519.57-.569,1.021-.545a.638.638,0,0,0,.679-.355.681.681,0,0,1,.717-.372c.712.019,1.423.071,2.135.078.318,0,.546-.055.668-.4s.433-.325.734-.27c.565.1.686.018.722-.534a1.405,1.405,0,0,1,.547-1.147,2.071,2.071,0,0,0,.977-1.989c-.158-1,.054-2.025-.1-3.033a1.074,1.074,0,0,1,.162-.7c-.04-.179.155-.268.164-.428-.064-.082-.134-.159-.192-.245-.338-.5-.337-.5-.885-.557a3.333,3.333,0,0,1-1.166.246,4.092,4.092,0,0,0-1.217.13.475.475,0,0,0-.278.371.781.781,0,0,1-1,.72c-.03,0-.063-.025-.088-.018-.827.24-1.264-.428-1.826-.792a.544.544,0,0,1-.21-.609c.053-.23.271-.2.448-.223a12.493,12.493,0,0,1,2.936.115c.486.039.933-.247,1.427-.157.107.019.208-.1.209-.206.009-.656.317-1.292.093-1.969-.152-.457-.212-.546-.7-.5-.374.038-.667-.019-.753-.453a.5.5,0,0,0-.332-.348c-.141-.064-.323-.152-.306-.3.062-.559-.207-1.1-.055-1.663.057-.213.169-.382.385-.394a2.046,2.046,0,0,1,1.15.129.556.556,0,0,0,.425.1.256.256,0,0,1,.308.137.7.7,0,0,0,.486.374.384.384,0,0,1,.3.445.317.317,0,0,0,0,.091c.059.28-.13.651.214.823.4.2.841.4,1.244-.031a.158.158,0,0,0,.036-.123.659.659,0,0,1-.219-.607c.051-.389-.028-.781-.007-1.175a.58.58,0,0,0-.426-.665c-.058-.016-.14-.032-.159-.08a1.468,1.468,0,0,0-.8-.831c-.228-.107.038-.376.049-.576,0-.062-.046-.083-.1-.088-.272-.036-.525.094-.8.077-.376-.023-.642-.138-.727-.541-.028-.134-.028-.326-.261-.29a.412.412,0,0,0-.562-.376c-.358.18-.667-.029-.979,0-.5.049-1.044-.279-1.506.141-.1.086-.285-.012-.358.2-.067.194-.4.239-.458.16-.383-.506-.335.015-.436.166a.465.465,0,0,1-.4.262c-.424-.019-.617.27-.84.558a2.4,2.4,0,0,0-.619,1.006c-.016.07.011.2-.063.2-.434-.04-.419.285-.47.552-.035.183-.056.321-.291.392-.339.1-.392.486-.554.75a4.843,4.843,0,0,0-.336.86c-.174.075-.3.14-.109.353a1.127,1.127,0,0,1,.265.636.254.254,0,0,0,.132.337c.176.083.141.239.166.376a.228.228,0,0,1,.006.083c-.008.039-.037.044-.047.012-.038-.131.04-.286-.085-.4a.4.4,0,0,1-.2-.512c-.247-.272-.526-.531-.317-.959.022-.044-.066-.088-.125-.1-.1-.157-.1-.157.185-.25-.163-.11-.366.033-.5-.12-.04-.046-.186-.073-.135.1.021.072-.059.142-.072.123-.315-.447-.749.1-1.084-.134-.04.044-.1.133-.118.125-.6-.205-1.072.547-1.687.239-.251.308-.713.029-.975.363-.127.16-.4-.093-.571.1-.219.034-.441.2-.643-.078-.071-.1-.169.041-.247.111-.164.147-.252.382-.5.432a.788.788,0,0,1-.675.252c-.047,0-.1.081-.141.133-.1.13-.158.318-.363.1a.184.184,0,0,0-.281.049c-.242.526-.823.434-1.189.691-.223.157-.55.23-.682.537a1.131,1.131,0,0,1-.625.651c-.323.094-.3.315-.348.513C2968.382,316.917,2968.468,316.557,2968.241,316.671Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M2990.054,318.291a.477.477,0,0,0-.3.505c.034.69.077,1.375.044,2.073-.025.542.027,1.114.046,1.672.013.36.045.739-.452.845-.115.025-.156.169-.2.29-.079.235-.19.436-.487.473a.353.353,0,0,0-.315.428c.036.287-.1.551-.051.85.032.189-.1.391-.42.265-.638-.249-.843-.147-1.088.478-.071.184-.2.151-.332.147-.791-.027-1.582-.043-2.372-.089a.633.633,0,0,0-.746.437c-.088.271-.282.308-.534.3-.269,0-.671-.13-.782.081-.252.479-.885.629-.98,1.208a.28.28,0,0,1-.316.255c-.215.005-.438.086-.454.3-.043.563-.409.461-.742.388-.366-.08-.634.046-.693.386-.074.418-.341.444-.623.37-.467-.122-.737.005-.819.486a.205.205,0,0,1-.214.194c-.139-.006-.128-.135-.152-.238a.57.57,0,0,0-.757-.493,2.88,2.88,0,0,1-.94.011c-.657-.049-1.319-.034-1.978-.029a.3.3,0,0,0-.336.248l.093.015a1.749,1.749,0,0,0,.888.035c.707-.024,1.413.076,2.118.025.494-.036.579.33.726.652.246.144.492.324.751.02s.349-.016.492.145c.078-.167.15-.313.214-.462.053-.122.2-.178.247-.1.236.36.337.077.461-.08.145-.184.251-.3.313.056.02.116.111-.015.171-.023a3.254,3.254,0,0,1,.18-.358c.214-.327.472-.489.828-.179.04-.234.061-.462.4-.473.206-.007.107-.278.276-.4.438-.327.889-.635,1.328-.958.25-.157.425-.459.795-.379.13.028.108-.106.132-.188.108-.357.438-.321.7-.338.133-.009.138.167.032.278l.049.072c.321-.252.783.045,1.1-.291.143-.153.3-.053.4.113l.273-.06a2.42,2.42,0,0,0,.94-.574.646.646,0,0,1,.86-.13c.12-.3.448-.429.606-.711a1.026,1.026,0,0,1,.574-.078c.277-.247.173-.658.438-.947a2,2,0,0,1,.5-.41c-.028-.2-.078-.366.257-.373.224,0,.169-.311.216-.485.066-.241-.149-.592.308-.68.051-.01.023-.306-.017-.471a.982.982,0,0,1,.063-.786c.135-.225-.123-.489.019-.736.148-.046.1.171.242.166.086-.248-.046-.487-.066-.733a2.128,2.128,0,0,1-.473-1.335c.005-.227-.225-.458-.348-.687A.046.046,0,0,0,2990.054,318.291Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M2975.537,336.253a7.774,7.774,0,0,1,1.313.694c.369.3.939.126,1.385.333.081.038.14-.042.136-.128-.006-.142.053-.356-.157-.368-.642-.038-1.012-.578-1.55-.8a1.209,1.209,0,0,1-.551-.522c-.053-.089-.136-.2-.025-.283s.17.058.246.123c.643.545,1.252,1.219,2.2,1.056a16.394,16.394,0,0,0,2.017-.064,1.415,1.415,0,0,1,.9.224.39.39,0,0,0,.509-.15c.085-.177-.186-.231-.25-.374a1.4,1.4,0,0,0-.9-.39,9.133,9.133,0,0,0-2.17-.2,3.8,3.8,0,0,1-1.084-.091,1.637,1.637,0,0,1-1.19-.943,13.419,13.419,0,0,1-1.043-2.312,1.554,1.554,0,0,0-.324-.834c-.41-.133-.847-.156-1.251-.315a.291.291,0,0,0-.333.054h-.574c.266.376.487.729.748,1.05a4.334,4.334,0,0,1,.744,2.1.535.535,0,0,1-.2.477,8.24,8.24,0,0,0-.63.764c-.054.073-.141.182-.048.286.075.085.17,0,.256,0,.3,0,.364-.278.515-.45.078-.09.13-.237.266-.21.2.04.054.2.058.3a.567.567,0,0,0,.48.573A.653.653,0,0,1,2975.537,336.253Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M2972.82,330.167a2.912,2.912,0,0,0-1.827-.23c-.362.034-.683-.086-1.026-.08-.054,0-.158-.09-.157-.137.015-.745-.6-.465-.948-.551-.423-.106-.6-.265-.513-.717.129-.679-.039-.855-.7-.7-.307.071-.676-.066-.907.283-.043.065-.164-.031-.245-.069-.007.122.05.244.165.219.292-.065.254.2.374.3a1.688,1.688,0,0,1,.583.908c.007.034.164.137.23.232.262.073.309.356.493.505.537-.269.828.234,1.228.392l.291.091a.847.847,0,0,0,.924.039.555.555,0,0,1,.665.147c.086.082.138.164.228.09C2972.032,330.6,2972.57,330.608,2972.82,330.167Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M2976.884,330.864c.01-.666-.174-.759-.876-.756-.805,0-1.611-.049-2.418-.026-.157,0-.289.072-.438.07.108.173.083.513.469.328.066-.032.231.141.349.22.027.326.246.378.511.349a3.037,3.037,0,0,1,.71-.079c.215.042.4-.1.6-.118.117-.016.235-.012.353-.021a.283.283,0,0,1,.324.09c.146.178.291.091.43-.019l-.021-.015Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M2975.249,330.888c-.234-.249-.5-.024-.674.044-.333.132-.465.005-.6-.232a2.826,2.826,0,0,1-.345-.042c-.113-.027-.244-.1-.324.008-.09.126.094.191.122.3.215-.028.382.12.574.158a2.725,2.725,0,0,0,.974.133.406.406,0,0,1,.313-.029.226.226,0,0,0,.172-.068C2975.536,330.953,2975.358,330.948,2975.249,330.888Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M2978.993,334.426c-.515-.53-.55-1.3-.967-1.89a2.9,2.9,0,0,1-.5-1.055c-.051-.227-.3-.28-.536-.223a1.98,1.98,0,0,1-.474-.149c-.148-.04-.307-.085-.429.038s-.042.285.019.42c.2.425.441.825.6,1.27s.255.83-.178,1.19c-.241.2-.08.468.115.568a2.818,2.818,0,0,0,2.155.444c.275-.082.387-.215.279-.494A1.348,1.348,0,0,0,2978.993,334.426Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M2979,334.55c.072.268-.028.4-.31.394-.5-.007-1.034.163-1.453-.246-.181-.178-.494.074-.619-.24-.06-.151-.21-.246.032-.392.366-.22.377-.567.269-.952a10.783,10.783,0,0,0-.726-1.659c-.038-.08-.2-.153-.067-.262.08-.067.213-.01.3-.031.216-.054.332.384.566.1a.477.477,0,0,1-.09-.356c-.154-.038-.345.148-.438-.206-.076-.285-.229.128-.382.11-.089.018-.188.188-.263-.017-.235-.235-.35.212-.564.1.052.09.192.116.182.251a4.513,4.513,0,0,1,1.056,1.841.935.935,0,0,1-.095.813,5.817,5.817,0,0,1-.86-1.768,5.5,5.5,0,0,0-.263-.861c-.072-.049-.149-.143-.214-.136-.115.014-.064.145-.084.227a18.649,18.649,0,0,0,1.227,3.092,2.077,2.077,0,0,0,2.173,1.157,11.69,11.69,0,0,1,2.833.32c.172.05.341.11.512.166.061-.182.21-.392-.175-.391-.135,0-.182-.138-.173-.272.015-.167-.1-.261-.209-.354A10.118,10.118,0,0,0,2979,334.55Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M2981.182,335.062l.186.265a1.153,1.153,0,0,0,.834.284c.683-.006,1.414.3,2.1-.316a21.042,21.042,0,0,0-3.042-.4C2981.111,334.889,2981.113,334.959,2981.182,335.062Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M2981.182,335.062l.082-.167a11.659,11.659,0,0,0-2.271-.469l.005.124C2979.7,334.841,2980.473,334.811,2981.182,335.062Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M2979.8,314.109c.043-.062.172-.118.041-.2s-.224-.168-.15-.348c.036-.09-.012-.16-.131-.179-.419-.069.05-.175-.008-.261-.109-.052-.142-.241-.316-.178l.116.124c-.356.186-.108.418-.1.664.008.364.331.114.377.293C2979.667,314.084,2979.7,314.153,2979.8,314.109Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M2989.31,309.093a.479.479,0,0,0-.271.527c.039.228.223.291.444.307.2.014.341.11.325.349-.015.223.06.376.321.393.3.019.405.259.414.5a12.465,12.465,0,0,1-.031,1.41c-.022.286.05.441.352.443.1.022.152-.076.259-.1-.064.137-.033.37-.289.189a.6.6,0,0,0-.418.147,2.056,2.056,0,0,1-.9-.241c.07-.245-.091-.48-.02-.71.106-.345-.036-.517-.354-.6-.2-.051-.415-.085-.431-.369,0-.052-.109-.147-.158-.141a2.453,2.453,0,0,1-.983-.254c-.09-.025-.206.053-.3.043-1.028-.107-1.392.373-1.031,1.375a.578.578,0,0,1,.032.4c-.163.437-.023.7.428.808a.292.292,0,0,1,.231.244c.15.555.33.688.906.547.329-.08.386.016.5.3.262.691-.076,1.344-.048,2.015.009.218-.213.176-.354.148s-.265-.111-.4-.042a3.084,3.084,0,0,1-1.886.048,10.478,10.478,0,0,0-2.183.019.3.3,0,0,0-.261.323c-.015.276.024.657.264.717.406.1.545.43.8.658.093.083.195.213.294.189.6-.146,1.247.149,1.829-.176a.359.359,0,0,0,.217-.444.453.453,0,0,1,.053-.43c-.146-.21-.343-.187-.555-.132a1.077,1.077,0,0,1-.69.063,13.011,13.011,0,0,1-1.338-.09c.453.042.925-.385,1.36.07a.214.214,0,0,0,.218.01,1.372,1.372,0,0,1,1.127-.151c.358-.269.742-.082,1.116-.063a3.29,3.29,0,0,1,.565-.1c.207-.027.464-.02.553-.294.437-.38,1-.561,1.465-.894.044-.264.342-.258.468-.44.072-.1.249-.164.176-.32-.062-.132-.213-.031-.323-.052a1.8,1.8,0,0,0-.221-.014.378.378,0,0,1-.547.012.722.722,0,0,0-.535-.013.942.942,0,0,1-.338.256.254.254,0,0,1-.16.057c-.009,0-.013-.014-.011-.021a.2.2,0,0,0,.129-.006,1.978,1.978,0,0,0,.377-.282q.235-.213.473-.424c.233-.367.618-.349.965-.325a4.927,4.927,0,0,1,1.665.344.806.806,0,0,0,.354.049c.1.016.185.133.29.031.088-.086.013-.174-.021-.249a1.886,1.886,0,0,0-.218-.394c-.46-.578-.927-1.149-1.395-1.72-.1-.121-.18-.279-.391-.125-.11.081-.205,0-.182-.144.014-.088.068-.169.023-.262-.051-.108-.134-.24.027-.308.192-.082.133.149.217.212s.153.131.268.231c-.029-.245.087-.453-.064-.647a.561.561,0,0,1-.117-.45,7.184,7.184,0,0,0-1.076-1.349.258.258,0,0,1-.107-.277C2989.99,309.151,2989.585,309.27,2989.31,309.093Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M2990.027,315.216c.146-.025.306.008.427-.111a2.8,2.8,0,0,1,1.04,0,6.814,6.814,0,0,1,1.03.054c.086,0,.3.157.287-.119a3.82,3.82,0,0,0-2.443-.461c-.248.03-.358.267-.545.391-.056.071-.126.147-.046.236S2989.943,315.255,2990.027,315.216Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M2989.846,315.043c.758-.728,1.587-.291,2.4-.141.191.036.379.1.568.143l.132-.112a4.876,4.876,0,0,0-2.754-.484c-.295.024-.185.311-.343.407A.125.125,0,0,0,2989.846,315.043Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M2989.846,315.043v-.187c-.165.108-.335.211-.366.433l-.01-.01c.184.05.362.25.554.019a.367.367,0,0,1,0-.082C2989.935,315.192,2989.765,315.248,2989.846,315.043Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M2991.494,315.11a1.74,1.74,0,0,0-1.04,0Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M2989.006,317.006a1.184,1.184,0,0,1-.77.186c-.182-.035-.263.11-.4.136-.01.139.1.143.191.17.241-.123.512-.026.768-.108a.573.573,0,0,0,.34-.255Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M2990.054,318.291l.039.005.039-.01c.014-.037.02-.1.044-.105.1-.034.222.2.285,0,.054-.163-.135-.193-.25-.248C2990.119,318.037,2989.939,318.1,2990.054,318.291Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M2987.42,308.251c.043.041.111.074.126.123a1.01,1.01,0,0,0,1.664.631c.062-.265,0-.439-.313-.438-.409.122-.522-.28-.775-.435C2987.92,308.359,2987.6,307.921,2987.42,308.251Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M2983.188,321.861a3.406,3.406,0,0,1-2.294,2.331,1.825,1.825,0,0,0-.541.3c-.008.1.018.158.133.117a4.919,4.919,0,0,0,2.8-2,1.878,1.878,0,0,0,.263-.843C2983.39,321.642,2983.3,321.806,2983.188,321.861Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M2974.521,325.688a1.5,1.5,0,0,0-.291.11.931.931,0,0,1-1.026.117c-.332-.165-.745-.032-1.121-.055-.13-.07-.26-.282-.391,0a3.232,3.232,0,0,0,2.229.335c.27-.029.625.053.789-.3.035-.069.142-.131.047-.217A.183.183,0,0,0,2974.521,325.688Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M2970.963,322.151c-.274.171-.274.171-.34-.005l-.04-.041c-.028.012-.079.02-.081.034-.077.53-.6.823-.71,1.322a2.05,2.05,0,0,0,.092.679.176.176,0,0,0,.26,0c.117-.175.264-.348.011-.532a.93.93,0,0,1-.087-.081c.337-.086.031-.552.421-.667.218-.065.369-.357.55-.547A.174.174,0,0,0,2970.963,322.151Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M2974.521,325.688c.145-.006.265.01.189.206.45-.057.905.2,1.369-.063.093-.052.373.229.551-.046a.13.13,0,0,0-.109-.107l-.128.011c-.074-.567-.326-.212-.522-.1-.157.089-.26.183-.331-.11-.045-.185-.26-.267-.477-.107A5.589,5.589,0,0,1,2974.521,325.688Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M2972.253,320.686l1.424-.361,0-.068-.525-.113c.524-.179.949-.325,1.375-.466.083-.028.2-.015.175-.149s-.136-.114-.217-.089a4.122,4.122,0,0,0-1.418.583,4.343,4.343,0,0,1-.916.561C2972.132,320.671,2972.151,320.722,2972.253,320.686Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M2971.692,325.859c.131-.157.261-.014.391,0a.2.2,0,0,0-.189-.159,2.79,2.79,0,0,1-1.571-.835c-.1-.055-.221-.061-.247-.217-.017-.1-.114-.124-.207-.054a.7.7,0,0,0,.4.741A3.683,3.683,0,0,0,2971.692,325.859Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M2983.2,319.362c-.095-.167-.072-.428-.365-.438a.131.131,0,0,1-.119-.163c.032-.152.084-.319-.092-.4a5.065,5.065,0,0,0-.645-.211.1.1,0,0,0-.138.081c-.024.125.091.163.163.18.534.123.445.819.923,1,.038.015-.085.251.067.351C2983.229,319.716,2983.166,319.514,2983.2,319.362Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M2980.486,324.613l-.133-.117c-.471.137-.773.554-1.226.767-.058-.19.3-.171.155-.329-.161-.177-.251.077-.38.115-.081.023-.142.111-.222.141-.117.044-.361-.12-.325.147.025.189.228.041.347.065C2979.484,325.561,2979.932,324.966,2980.486,324.613Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M2972.253,320.686l-.1-.1a4.343,4.343,0,0,0-1.568,1.06c-.168.2-.141.257.114.212l-.01.009a1.929,1.929,0,0,1,1.375-.832c.045-.072.22,0,.182-.166l-.221-.031Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M2976.521,325.678l.109.107c.3-.345.78-.112,1.121-.342.114-.077.372-.056.31-.24s-.286-.107-.436-.042C2977.252,325.322,2976.756,325.224,2976.521,325.678Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M2985.351,317.677a.673.673,0,0,0,.677.051.729.729,0,0,1,.622-.04l.131-.092c-.335,0,.063-.149-.041-.2-.467-.313-.862-.038-1.268.155A.152.152,0,0,0,2985.351,317.677Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M2983.093,320.035c-.233.44.256.77.182,1.186a.14.14,0,0,0,.205-.006,1.982,1.982,0,0,0-.223-1.359C2983.056,319.78,2983.023,319.861,2983.093,320.035Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M2986.74,317.4l-.181.16.222.035,1.245-.1-.191-.17A.907.907,0,0,0,2986.74,317.4Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M2971.062,321.865c.49-.14.955-.352,1.445-.5a1.9,1.9,0,0,0-1.543.412C2970.954,321.853,2970.97,321.9,2971.062,321.865Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M2990.834,313.109c.007.1-.166.228.045.287.114.032.206,0,.225-.139a.635.635,0,0,1,.035-.128c.051-.147.345-.3.1-.433-.209-.115-.3.153-.38.327Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M2972.241,320.867l-.182.166,1.165-.075A1.041,1.041,0,0,0,2972.241,320.867Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M2979.8,314.109l-.173-.088c-.218.278-.116.438.194.522.1,0,.122.062.124.145s.008.188.148.149c0-.222.033-.452-.289-.512C2979.664,314.3,2979.772,314.184,2979.8,314.109Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M2980.092,314.837c-.185-.011.011-.375-.272-.294.2.135-.16.257-.011.383.092.079.077.312.254.244C2980.215,315.112,2980.2,314.96,2980.092,314.837Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M2970.963,322.151l.076.158c.2-.1.464-.085.6-.328A.892.892,0,0,0,2970.963,322.151Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M2983.48,321.215l-.205.006a.458.458,0,0,1-.087.64l.363-.094A.448.448,0,0,0,2983.48,321.215Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M2969.869,324.6c.2,0,.2.356.454.271a.3.3,0,0,1-.082-.447c-.136-.1-.315-.1-.458-.179C2969.548,324.423,2969.8,324.486,2969.869,324.6Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M2969.783,324.24c.068.277.266.219.458.179a.223.223,0,0,0-.1-.283l-.26,0Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M2971.062,321.865l-.1-.088-.28.088.01-.009-.111.249.008.032.032.009A.86.86,0,0,0,2971.062,321.865Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M2983.093,320.035c0-.109.046-.177.164-.179-.252-.137.083-.343-.057-.494l-.206.4C2983,319.866,2982.959,319.981,2983.093,320.035Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M2975.813,330.789c-.054.106-.218.249-.006.306.137.037.28-.1.269-.289C2976,330.653,2975.9,330.748,2975.813,330.789Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M2981.141,335.461a3.887,3.887,0,0,0-1.321-.5A1.656,1.656,0,0,0,2981.141,335.461Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M2978.628,335.239a6.57,6.57,0,0,0,1.21.106c-.389-.427-.806-.243-1.21-.161Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M2978.628,335.239a.123.123,0,0,0,0-.055,4.487,4.487,0,0,0-1.06.022A4.269,4.269,0,0,0,2978.628,335.239Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M2987.387,311.772c-.1-.11-.211-.293-.335-.06-.161.3-.273.627-.406.942.214.149.3,0,.386-.159.259.183.541.21.643-.118.084-.272.239-.277.441-.287a.25.25,0,0,0,.1-.081c-.038-.207-.184-.244-.361-.23A3.538,3.538,0,0,1,2987.387,311.772Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M2985.351,317.677l.121-.121c-.125-.5-.506-.262-.79-.257s-.532.236-.814.026c-.02-.015-.09.007-.114.033a.1.1,0,0,0,.027.154c.073.05.163.132.233.122C2984.464,317.569,2984.9,317.9,2985.351,317.677Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M2988.211,312.012l-.133.018c-.029.342.082.739-.361.918-.115.048-.242.028-.357.068s-.226.08-.186.21c.049.159.179.124.3.065a.37.37,0,0,1,.4.094.8.8,0,0,1,.362-.178.537.537,0,0,0,.412-.7C2988.517,312.329,2988.521,312.035,2988.211,312.012Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M2988.211,312.012c.228.072.121.409.369.466a.727.727,0,0,1,.033.307c.011.15.067.229.227.145a1.3,1.3,0,0,0-.752-1.363c-.215-.064-.261.044-.25.224l-.021.045A.6.6,0,0,1,2988.211,312.012Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M2987.47,313.291c-.082-.01-.2.033-.224-.081-.016-.093.089-.1.162-.1.144-.018.3.041.429-.074-.328-.193-.739-.293-.837-.745-.118.122-.045.429-.354.367.17.26.243.6.587.717A.187.187,0,0,0,2987.47,313.291Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M2988.84,312.93c-.377.016-.031-.383-.26-.452.094.473-.266.6-.584.747-.08.037-.187.02-.128.159C2988.25,313.356,2988.71,313.495,2988.84,312.93Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M2989.749,314.7c-.142-.205-.31-.037-.425-.169-.064-.109.075-.11.118-.17a.159.159,0,0,0-.017-.238c-.077-.052-.211-.037-.239.044-.053.151-.342.2-.192.434.059.094.1.294.23.2C2989.384,314.681,2989.567,314.8,2989.749,314.7Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M2992.029,313.871c-.094-.183-.34-.148-.468-.3-.071-.084-.191-.173-.315-.09-.1.064-.032.167,0,.243.115.27.349.29.6.27A.187.187,0,0,0,2992.029,313.871Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M2989.914,314.091a.583.583,0,0,0,.127.022c.159-.026.337.072.474-.058.049-.047-.008-.131-.059-.149A.422.422,0,0,0,2989.914,314.091Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M2987.817,311.836a.065.065,0,0,1,.021-.045c-.036-.027-.1-.049-.1-.081-.027-.158-.052-.295-.27-.252-.262.052.091.246-.078.314C2987.518,311.879,2987.673,311.815,2987.817,311.836Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M2990.614,313.688a.316.316,0,0,0,.276.2c.1.012.152-.043.112-.132s-.082-.241-.247-.216A.145.145,0,0,0,2990.614,313.688Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M2989.109,315.557a.354.354,0,0,0-.48.069c.2.13.349.128.472-.079Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M2989.1,315.547c.224.05.429.073.369-.268l.01.01c-.215-.036-.3.107-.37.269Z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M2987,312.287c.077.587.2.7.837.745.411-.283.469-.523.241-1l-.4-.069c-.1.09.041.178.011.271a.428.428,0,0,1-.29.31c-.216.059-.278-.1-.322-.266,0-.008-.024-.016-.035-.014A.12.12,0,0,0,2987,312.287Z",
    fill: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 66.178,
    height: 4.944,
    transform: "translate(2943.865 336.226)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 52.279,
    height: 4.944,
    transform: "translate(2950.815 343.331)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 1.482,
    height: 4.944,
    transform: "translate(2948.218 343.331)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 1.482,
    height: 4.944,
    transform: "translate(3004.265 343.331)",
    fill: "#b7b7b7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneGreyIcon);
export default __webpack_public_path__ + "static/media/zoneGreyIcon.b27677bf6431d31d856beb5595aecb5a.svg";
export { ForwardRef as ReactComponent };